import React from 'react';
import { Header } from './components/Header';
import { Introduction } from './components/Introduction';
import { SignalsList } from './components/SignalsList';
import { CommunicationGap } from './components/CommunicationGap';
import { WebinarInfo } from './components/WebinarInfo';
import { Testimonials } from './components/Testimonials';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
import { HotjarTracking } from './components/HotjarTracking';
import { FacebookPixel } from './components/FacebookPixel';
import { GoogleTag } from './components/GoogleTag';
export function App() {
  return <div className="flex flex-col min-h-screen w-full bg-white" data-id="element-0">
      <HotjarTracking data-id="element-1" />
      <FacebookPixel data-id="element-2" />
      <GoogleTag data-id="element-3" />
      <main className="flex-grow" data-id="element-4">
        <Header data-id="element-5" />
        <Introduction data-id="element-6" />
        <CommunicationGap data-id="element-7" />
        <SignalsList data-id="element-8" />
        <WebinarInfo data-id="element-9" />
        <Testimonials data-id="element-10" />
        <CTASection data-id="element-11" />
        <Footer data-id="element-12" />
      </main>
    </div>;
}